import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  isLoading?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  isLoading,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg px-6 py-3 font-semibold transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#6366F1] text-white hover:bg-[#5558E3] focus:ring-[#6366F1]',
    secondary: 'bg-[#EC4899] text-white hover:bg-[#DB2777] focus:ring-[#EC4899]',
    outline: 'border-2 border-[#6366F1] text-[#6366F1] bg-transparent hover:bg-[#6366F1] hover:text-white focus:ring-[#6366F1]'
  };
  return <motion.button whileHover={{
    scale: 1.05,
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-23">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-24" />}
      {children}
    </motion.button>;
}